// extracted by mini-css-extract-plugin
export default {"container":"Content-module__container--Q2kHe","pagination":"Content-module__pagination--zH9qe"};